import {ApiService} from "./api.service";
import {Injectable} from "@angular/core";
import {Meta} from '@angular/platform-browser';

@Injectable()
export class MetatagService {
    constructor(
        private apiService: ApiService,
        private metaService: Meta) {}

    public getPageInfo(path: string) {
        return this.apiService.get(path)
            .map((res) => {
                return ApiService.extractData(res);
            })
            .catch((err) => {
                return ApiService.handleError(err);
            });
    }

    public setMetaTags(description: string, keywords: string) {
        this.metaService.removeTag('name="description"');
        this.metaService.removeTag('name="keywords"');
        this.metaService.addTag({ name: 'description', content: description});
        this.metaService.addTag({ name: 'keywords', content: keywords});
    }
}



// WEBPACK FOOTER //
// D:/Documents/FTP/derma/dermabase.nl_backup/src/app/services/metatag.service.ts